// extracted by css-extract-rspack-plugin
export default {"toast":"mK871z72pIghGDVf__toast___"};